import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'app/services/utils.service';
import { environment } from 'environments/environment';
import { TransactionFilter } from 'app/models/TransactionFilter';
import { Transaction } from 'app/models/Transaction';

// 
@Component({
	selector: 'vbn-kiosk-payments',
	templateUrl: './kiosk-payments.component.html',
	styleUrls: ['./kiosk-payments.component.scss']
})
export class KioskPaymentsComponent implements OnInit {

	transactionFilter: TransactionFilter;
	transactionList: Transaction[];
	pageNumber: number = 1;
	itemPerPage: number = 15;
	configPagination: any;
	isOnResponsive: boolean = false;
	selectedClient: string;
	errorMessage: string;
	isLoading: boolean = false;

	constructor(private router: Router, private _notificationService: NotificationsService,
		private translate: TranslateService, private service: UtilsService) {
		this.transactionFilter = new TransactionFilter();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event) {
		const innerWidth = window.innerWidth;
		if (innerWidth <= 1300) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	ngOnInit() {
		this.selectedClient = this.service.currentUserEmail;
		this.getTransactionList();

		if (innerWidth <= 1300) {
			this.isOnResponsive = true;
		}
		else {
			this.isOnResponsive = false;
		}
	}

	handlePageChange(event) {
		this.pageNumber = event
		this.getTransactionList()
	}

	showResponsiveDetails(transactionId) {
		const width = window.innerWidth;
		if (width <= 1300) {
			for (let i = 0; i < this.transactionList.length; i++) {
				if (this.transactionList[i].transactionId === transactionId) {
					this.transactionList[i].showDetailsOnResponsive = !this.transactionList[i].showDetailsOnResponsive;
				}
				else {
					this.transactionList[i].showDetailsOnResponsive = false;
				}
			}
		}
		else {
			return;
		}

	}

	resetFilter() {
		this.transactionFilter = new TransactionFilter();
		this.getTransactionList();
	}

	exportTransactions() {
		this.transactionFilter.clientEmail = this.selectedClient;
		const params = this.transactionFilter.toQueryString();
		this.isLoading = true;
		this.service.downloadFile(environment.taxesAndFeesURL + `/transaction/exportTransactionsByFilters?${params}`)
			.subscribe(
				response => {
					const blob = new Blob([response.body], { type: response.body.type });

					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.errorMessage = <any>error
				});
	}

	getTransactionList() {
		this.transactionFilter.clientEmail = this.selectedClient;
		this.transactionFilter.pageNumber = this.pageNumber;
		this.transactionFilter.itemPerPage = this.itemPerPage;
		const params = this.transactionFilter.toQueryString();
		this.isLoading = true;

		this.service.get(environment.taxesAndFeesURL + `/transaction/getTransactionsByFilters?${params}`)
			.subscribe(
				response => {
					this.transactionList = response.transactionList;
					this.configPagination = {
						cap: response.totalPages,
						start: this.pageNumber
					}
					this.isLoading = false;
				},
				error => {
					this.isLoading = false;
					this.errorMessage = <any>error
				});
	}

	getParsedErrorMessage(errorMessage: any) {
		if (errorMessage && errorMessage.startsWith('Unknown POS response: {')) {
			try {
				let json = JSON.parse(errorMessage.substring('Unknown POS response:'.length));
				let responseText = (json.cardHostResponseText && json.cardHostResponseText.value)
					? json.cardHostResponseText.value
					: 'Unknown Response Text';
				let responseCode = (json.cardHostResponseCode && json.cardHostResponseCode.value)
					? `Response Code: ${json.cardHostResponseCode.value}`
					: 'Response Code: Unknown';
				return `${responseText} ${responseCode}`;
			} catch (error) {
				return 'Invalid JSON response';
			}
		} else {
			return errorMessage;
		}
	}
}
